<ng-container *ngIf="flightsSeats.length === 0">
  <div class="{{ bodyClass }} regular-type ps-xxsmall-b grey-600-text text-icon-disabled-text">
    {{ 'MMB.services.seats.noneIncluded' | finLocalization }}
  </div>
</ng-container>
<span data-testid="product-item-summary-selected-seats" *ngIf="flightsSeats.length === 1" class="comma-separated">
  <span *ngFor="let seat of flightsSeats[0].seats" class="{{ bodyClass }} regular-type ps-xxsmall-b">
    {{ seat }}
  </span>
</span>
<ng-container *ngIf="flightsSeats.length > 1">
  <span *ngFor="let flightSeats of flightsSeats; last as lastFlight" class="{{ bodyClass }} regular-type ps-xxsmall-b">
    {{ flightSeats.flight }}:
    <span [attr.data-testid]="`product-item-summary-selected-seats-${flightSeats.flight}`" class="comma-separated">
      <span *ngFor="let seat of flightSeats.seats" class="{{ bodyClass }} medium-type ps-xxsmall-b">
        {{ seat }}
      </span>
    </span>
    <span *ngIf="!lastFlight"> / </span>
  </span>
</ng-container>
